<h1 mat-dialog-title class="pt-2 text-center">Importer des documents</h1>
<div mat-dialog-content class="p-3">

    <!-- <div class="row">
  <button class="m-3 col" mat-raised-button color="accent" (click)="fileInput.click()">
    <input type="file" (change)="onFileChange($event)" [accept]="Accept" placeholder="Proposition de stratégie"
      #fileInput multiple>
      <mat-icon class="material-symbols-outlined" aria-label="add-image">cloud_upload</mat-icon> Parcourir les fichiers
    </button>
  </div> -->

    <div class="row">
        <div class="m-3 d-flex align-items-center justify-content-center col uploadfilecontainer" (click)="fileInput4DnD.click()" appDragDrop
            (onFileDropped)="onFileFromDragNDrop($event)">
            <input type="file" #fileInput4DnD (change)="onFileFromDragNDrop($event.target)" [multiple]="multiple">
            <mat-icon class="material-symbols-outlined mr-1" aria-label="add-image">cloud_upload</mat-icon> Déposer ou choisir un fichier
        </div>
    </div>

    <div class="row text-center">
        @switch (CurrentState) {
            @case (ELoadingState.Uploading) {
                <p class="fst-italic">Uploading...</p>
            }
            @case (ELoadingState.PendingServer) {
                @if (IsDocumentAPDRE) {
                <p class="fst-italic">Extracting information from the file...</p>
                } @else {
                <p class="fst-italic">Retrieving server response...</p>
                }
            }
            @case (ELoadingState.Finishing) {
                <p class="fst-italic">Finishing...</p>
            }
            @default {
                <p class="fst-italic">Waiting...</p>
            }
        }
    </div>

    <div class="row">
        <div class="col-1 mx-auto">
            @if (PercentDone !== 0 && PercentDone !== 101) {
            <circle-progress [percent]="PercentDone" [backgroundPadding]="1" [radius]="20" [space]="-2" [innerStrokeColor]="'#e7e8ea'" [innerStrokeWidth]="3" [animation]="true"
                [outerStrokeColor]="'#f50057'" [outerStrokeWidth]="3" [animateTitle]="false" [showTitle]="true" [titleFontSize]="'13'" [animationDuration]="10"
                [startFromZero]="true" [showSubtitle]="false" [showUnits]="true">
            </circle-progress>
            }
        </div>
    </div>
    <div class="row mt-2">
        <mat-chip-list class="col">
            @for (f of Files; track f) {
            <mat-chip selectable (removed)="remove(f)">
                {{f.name}}
                @if (true) {
                <mat-icon class="material-symbols-outlined" matChipRemove>cancel</mat-icon>
                }
            </mat-chip>
            }
        </mat-chip-list>
    </div>

    <div class="row d-flex justify-content-end">
        <button class="col-2 m-3" color="primary" mat-raised-button (click)="onCancel()" >
            Annuler
        </button>
        <button appPreventDoubleClick class="col-2 m-3" color="primary" mat-raised-button (throttledClick)="uploadDocument()" title="SaveDocument" [disabled]="!CanAddDocument">
            Ajouter
        </button>
    </div>
</div>